import { apiPost } from '@ibkr/clientportal.common/src/api/default'
import { PortalBaseUrl } from '@ibkr/clientportal.common/src/js/portalBaseUrl.js'

const base = '';

/**
 * @param args [{ type, data }]
 */
function report(args) {
    /**
     * This API was disabled in #master due to CLNTPORTAL-1065 but now has been enabled again
     * as only select metrics are being reported due to work done in CLNTPORTAL-2979
     */
    return apiPost(base + '/metrics/report', args);
}

function error(message) {
    //return new Promise(); // disable for now CLNTPORTAL-1065
    //const source = process.env.METRICS_SOURCE || '-';
    //return apiPost(base + '/metrics/error', { 'message': message, 'source': source });
}

export default {
    report,
    error
}
